import { AppContext } from '@thd-nucleus/app-render';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { useContext } from 'react';
import { BusinessToolsContext, CommonContext, DownloadContext, OrderContext, OrderDetailsContext, Phase0BarcodeContext, PTCDocumentsContext, PurchaseHistoryContext, ReturnLabelContext, SearchResultsContext, FulfillmentGroupContext, } from '../contexts';
export var useAppContext = function () {
    var context = useContext(AppContext);
    if (context === undefined) {
        throw new Error('useAppContext must be used within a AppProvider');
    }
    return context;
};
export var useBusinessToolsContext = function () {
    var context = useContext(BusinessToolsContext);
    if (context === undefined) {
        throw new Error('useBusinessToolsContext must be used within a BusinessToolsProvider');
    }
    return context;
};
export var useCommonContext = function () {
    var context = useContext(CommonContext);
    if (context === undefined) {
        throw new Error('useCommonContext must be used within a CommonProvider');
    }
    return context;
};
// Contexts hook for Downloads Page
export var useDownloadsContext = function () {
    var context = useContext(DownloadContext);
    if (context === undefined) {
        throw new Error('useDownloadsContext must be used within a DownloadProvider');
    }
    return context;
};
// Contexts hook for Experience context
export var useExperienceContext = function () {
    var context = useContext(ExperienceContext);
    if (context === undefined) {
        throw new Error('useExperienceContext must be used within a ExperienceProvider');
    }
    return context;
};
export var useOrderDetailsContext = function () {
    var context = useContext(OrderDetailsContext);
    if (context === undefined) {
        throw new Error('useOrderDetailsContext must be used within a OrderDetailsProvider');
    }
    return context;
};
export var useOrderContext = function () {
    var context = useContext(OrderContext);
    if (context === undefined) {
        throw new Error('useOrderContext must be used within a OrderProvider');
    }
    return context;
};
export var usePurchaseHistoryContext = function () {
    var context = useContext(PurchaseHistoryContext);
    if (context === undefined) {
        throw new Error('usePurchaseHistoryContext must be used within a PurchaseHistoryProvider');
    }
    return context;
};
export var useSearchResultsContext = function () {
    var context = useContext(SearchResultsContext);
    if (context === undefined) {
        throw new Error('useSearchResultsContext must be used within a SearchResultsProvider');
    }
    return context;
};
export var useFulfillmentGroupContext = function () {
    var context = useContext(FulfillmentGroupContext);
    if (context === undefined) {
        throw new Error('useFulfillmentGroupContext must be used within a FulfillmentGroupProvider');
    }
    return context;
};
// ------------------------------------------- Below are hooks for components specifically ---------------------------------------
export var useReturnLabelContext = function () {
    var context = useContext(ReturnLabelContext);
    if (context === undefined) {
        throw new Error('useReturnLabelContext must be used within a ReturnLabelProvider');
    }
    return context;
};
export var usePhase0BarcodeContext = function () {
    var context = useContext(Phase0BarcodeContext);
    if (context === undefined) {
        throw new Error('usePhase0BarcodeContext must be used within a Phase0BarcodeProvider');
    }
    return context;
};
export var usePTCDocumentsContext = function () {
    var context = useContext(PTCDocumentsContext);
    if (context === undefined) {
        throw new Error('usePTCDocumentsContext must be used within a PTCDocumentsProvider');
    }
    return context;
};
